<template>

  <div class="page">
  		<div class="gridheader">
  			<div class="row wrapper">
  				<div class="col-md-4 title">
            <h1>{{$t('ORDINATIONSANDLABS')}}</h1>
            <ul class="list-unstyled">
  						<li><router-link to="/controlpanel/basic">{{ $t('BASICDATA')}}</router-link></li>
  						<li><router-link to="/controlpanel/connection">{{ $t('CONNECTINGTOOTHERCOMPANIES')}}</router-link></li>
              <li class="active"><router-link to="/ordinationsandlabs">{{$t('ORDINATIONSANDLABS')}}</router-link></li>
  					</ul>
          </div>
  				<div class="col-md-4">
  					<form method="get" action="">
  						<div class="input-group">
  							<input type="text" v-model="query" class="form-control" v-bind:placeholder="$t('SEARCHORDINATIONSANDLABS')">
                <div v-if="query == ''" class="input-group-addon"><img src="../assets/img/icon-search.svg" alt=""></div>
                <div v-if="query != ''" v-on:click="query = ''" class="input-group-addon"><img class="emptysearch" src="../assets/img/icon-close.svg" alt=""></div>
  						</div>
  					</form>
  				</div>
  				<div class="col-md-4 action"><a v-on:click="newOrdination" class="btn btn-primary"><img src="../assets/img/user-plus.svg" alt=""> {{$t('ADD')}}</a></div>
  			</div>
  		</div>
  		<div class="row">
        <div class="table-responsive">
    			<table class="maintable">
    				<thead>
    					<tr>
    						<td>{{$t('NAME')}}</td>
    						<td>{{$t('ADDRESS')}}</td>
    						<td>{{$t('OIB')}}</td>
    						<td>{{$t('PHONE')}}</td>
    						<td>{{$t('STATUS')}}</td>
                <td>{{$t('ACTIONS')}}</td>
    					</tr>
    				</thead>
    				<tbody>
    					<tr v-for="ordination in ordinations.root">
    						<td>{{ordination.companyName}}</td>
    						<td>{{ordination.address}}</td>
    						<td>{{ordination.oib}}</td>
    						<td>{{ordination.phone}}</td>
    						<td class="status" v-bind:class="ordination.status">{{ordination.statusOut}}</td>
                <td><a href="#" class="grid-action" v-on:click.prevent="editOrdination(ordination)"><img src="../assets/img/cell-edit.svg" alt=""></a></td>
    					</tr>
    				</tbody>
    			</table>
        </div>
  		</div>

      <b-pagination v-if="ordinations.totalCount > 20" align="center" :total-rows="parseInt(ordinations.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>

      <b-modal size="lg" ref="newordination" id="newordination" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveOrdination" v-bind:title="$t('NEW')">
        <form method="get" action="">
          <div class="row">
            <div class="col-md-3">
              <inputvalidation v-bind:label="$t('TYPE')" :formerror="formError" name="type"><b-form-select class="form-control secondary" :options="types" v-model="formData.type"></b-form-select></inputvalidation>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.companyName) ? 'has-danger' :''">
                <label>{{$t('COMPANYNAME')}}</label>
                <input type="text" v-model="formData.companyName" class="form-control secondary" v-bind:placeholder="$t('COMPANYNAME')">
                <div v-if="formError.notice && formError.notice.companyName" class="form-control-feedback">{{formError.notice.companyName}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.shortCompanyName) ? 'has-danger' :''">
                <label>{{$t('SHORTCOMPANYNAME')}}</label>
                <input type="text" v-model="formData.shortCompanyName" class="form-control secondary" v-bind:placeholder="$t('SHORTCOMPANYNAME')">
                <div v-if="formError.notice && formError.notice.shortCompanyName" class="form-control-feedback">{{formError.notice.shortCompanyName}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.oib) ? 'has-danger' :''">
                <label>{{$t('OIB')}}</label>
                <input type="text" v-model="formData.oib" class="form-control secondary" v-bind:placeholder="$t('OIB')">
                <div v-if="formError.notice && formError.notice.oib" class="form-control-feedback">{{formError.notice.oib}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <h2>{{$t('LOCATION')}}</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.address) ? 'has-danger' :''">
                <label>{{$t('ADDRESS')}}</label>
                <input type="text" v-model="formData.address" class="form-control secondary" v-bind:placeholder="$t('ADDRESS')">
                <div v-if="formError.notice && formError.notice.address" class="form-control-feedback">{{formError.notice.address}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.postalNum) ? 'has-danger' :''">
                <label>{{$t('POSTALNUM')}}</label>
                <input type="text" v-model="formData.postalNum" class="form-control secondary" v-bind:placeholder="$t('POSTALNUM')">
                <div v-if="formError.notice && formError.notice.postalNum" class="form-control-feedback">{{formError.notice.postalNum}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.city) ? 'has-danger' :''">
                <label>{{$t('CITY')}}</label>
                <input type="text" v-model="formData.city" class="form-control secondary" v-bind:placeholder="$t('CITY')">
                <div v-if="formError.notice && formError.notice.city" class="form-control-feedback">{{formError.notice.city}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.country) ? 'has-danger' :''">
                <label>{{$t('COUNTRY')}}</label>
                <input type="text" v-model="formData.country" class="form-control secondary" v-bind:placeholder="$t('COUNTRY')">
                <div v-if="formError.notice && formError.notice.country" class="form-control-feedback">{{formError.notice.country}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <h2>{{$t('CONTACT')}}</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.email) ? 'has-danger' :''">
                <label>{{$t('EMAIL')}}</label>
                <input type="text" v-model="formData.email" class="form-control secondary" v-bind:placeholder="$t('EMAIL')">
                <div v-if="formError.notice && formError.notice.email" class="form-control-feedback">{{formError.notice.email}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.phone) ? 'has-danger' :''">
                <label>{{$t('PHONE')}}</label>
                <input type="text" v-model="formData.phone" class="form-control secondary" v-bind:placeholder="$t('PHONE')">
                <div v-if="formError.notice && formError.notice.phone" class="form-control-feedback">{{formError.notice.phone}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.mobilePhone) ? 'has-danger' :''">
                <label>{{$t('MOBILEPHONE')}}</label>
                <input type="text" v-model="formData.mobilePhone" class="form-control secondary" v-bind:placeholder="$t('MOBILEPHONE')">
                <div v-if="formError.notice && formError.notice.mobilePhone" class="form-control-feedback">{{formError.notice.mobilePhone}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" v-bind:class="(formError.notice && formError.notice.webPage) ? 'has-danger' :''">
                <label>{{$t('WEBPAGE')}}</label>
                <input type="text" v-model="formData.webPage" class="form-control secondary" v-bind:placeholder="$t('WEBPAGE')">
                <div v-if="formError.notice && formError.notice.webPage" class="form-control-feedback">{{formError.notice.webPage}}</div>
              </div>
            </div>
          </div>
        </form>
      </b-modal>

  	</div>



</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import ordinationsApi from '@/api/ordinations'

export default {
  name: 'Ordinations',
  data: function()
  {
    var me = this;
    return {
      query: '',
      ordinations: {},
      formData: {
        id: '',
        companyId: '',
        companyName: '',
        shortCompanyName: '',
        oib: '',
        address: '',
        postalNum: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        mobilePhone: '',
        webPage: '',
        type: 'ordination'
      },
      formError: {},
      types:
      [
        {
          value: 'ordination',
          text: me.$i18n.t('ORDINATION')
        },
        {
          value: 'technicallab',
          text: me.$i18n.t('TECHNICALLAB')
        },
        {
          value: 'ordinationandlab',
          text: me.$i18n.t('ORDINATIONANDLAB')
        }
      ],
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function()
  {
    this.getOrdinations();
  },
  methods:
  {
    newOrdination: function()
    {
      var me = this;
      me.formData = {
        id: '',
        companyId: '',
        companyName: '',
        shortCompanyName: '',
        oib: '',
        address: '',
        postalNum: '',
        city: '',
        country: '',
        email: '',
        phone: '',
        mobilePhone: '',
        webPage: '',
        type: 'ordination'
      };
      me.$refs.newordination.show()
    },
    saveOrdination: function(bvEvt)
    {
      var me = this;

      bvEvt.preventDefault();

      ordinationsApi.saveOrdination(me.formData, function(val)
      {
        if(val.error)
        {
          me.formError = val;
        }
        else
        {
          me.formError = {};
          me.formData = {
            id: '',
            companyId: '',
            companyName: '',
            address: '',
            oib: '',
            phone: ''
          };
          me.$refs.newordination.hide()
          me.getOrdinations();
        }
      })
    },
    getOrdinations: function()
    {
      var me = this;
      ordinationsApi.getOrdinations(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.ordinations = data;
      });
    },
    deleteOrdination: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          ordinationsApi.deleteOrdination({id: id}, function(data)
          {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.getOrdinations();
          })
        }
      })
    },
    editOrdination: function(data)
    {
      var me = this;
      data = Object.assign({}, data, {});
      data.id = data.companyId;
      me.formData = data;
      me.$refs.newordination.show()
    }
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getOrdinations();
    },
    'pagination.query': function()
    {
      var me = this;
      me.getOrdinations();
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Ordinations.vue